<template>
    <div class="uploadFileSuccessAnimationWrap">
        <div class="circle"></div>
        <div class="top"></div>
        <div class="bottom"></div>
        <i class="iconfont icon-check"></i>
    </div>
</template>
<script>
    export default {
        name: 'UploadFileSuccessAnimation',// 上传文件成功的动画组件
    };
</script>
<style lang="scss" scoped>
    .uploadFileSuccessAnimationWrap {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 120px;
        height: 120px;
        overflow: hidden;
        transform: translate3d(-50%, -50%, 0);
    }

    .circle {
        box-sizing: border-box;
        height: 100%;
        border: 10px solid #67c23a;
        border-radius: 50%;
    }

    .circle::before {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 2;
        box-sizing: border-box;
        display: block;
        width: 100%;
        height: 50%;
        content: '';
        border: 10px solid #67c23a;
        border-top: transparent;
        border-radius: 0 0 50% 50%/ 0 0 100% 100%;
    }

    .top,
    .bottom {
        position: absolute;
        left: 0;
        box-sizing: border-box;
        width: 100%;
        height: 50%;
        background: white;
    }

    .top {
        top: 0;
        z-index: 1;
        transform-origin: center bottom;
        animation: 0.5s back-half ease-out 0.5s;
        animation-fill-mode: forwards;
    }

    .bottom {
        top: 50%;
        z-index: 3;
        transform-origin: center top;
        animation: 0.5s front-half ease-in;
        animation-fill-mode: forwards;
    }

    @keyframes front-half {
        0% {
            transform: rotate(0);
        }

        99% {
            opacity: 1;
            transform: rotate(180deg);
        }

        100% {
            opacity: 0;
            transform: rotate(180deg);
        }
    }

    @keyframes back-half {
        0% {
            transform: rotate(0);
        }

        99% {
            opacity: 1;
            transform: rotate(180deg);
        }

        100% {
            opacity: 0;
            transform: rotate(180deg);
        }
    }

    .iconfont {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 5;
        font-size: 60px;
        color: #67c23a;
        transform: translate3d(-50%, -50%, 0);
    }
</style>
